export const ConstantsAssamese = {
    patterns: [
        {
            "search_word":"য়",
            "replace_word":"য়"
        },
		{
            "search_word":"ড়",
            "replace_word":"ড়"
        },
        {
            "search_word":"ঢ়",
            "replace_word":"ঢ়"
        }
    ],
    //replacement while copying
    fix_patterns: [
        {
            "search_word":"য়",
            "replace_word":"য়"
        },
        {
            "search_word":"ড়",
            "replace_word":"ড়"
        },
        {
            "search_word":"ঢ়",
            "replace_word":"ঢ়"
        },
        {
            "search_word":"য়া",
            "replace_word":"য়া"
        },
        {
            "search_word":"ড়ো",
            "replace_word":"ড়ো"
        },
        {
            "search_word":"ঢ়ো",
            "replace_word":"ঢ়ো"
        },
        {
            "search_word":"ঢ়োঁ",
            "replace_word":"ঢ়োঁ"
        },
    ],
    variations:
    {
        // বিকল্প আখৰ আৰু শব্দৰ তালিকা।
        //"থকাটো":"বিকল্পটোটো" (থকাটো আছে, বিকল্পে ইটোও শুদ্ধ -এই কনচেপ্ট।// থকাটো বাওঁফালে //দিব লাগিব)
        "ক্ব": ["ক্ৱ"],
		"গ্ব": ["গ্ৱ"],
		"জ্ব": ["জ্ৱ"],
		"ণ্ব": ["ণ্ৱ"],
		"ত্ব": ["ত্ৱ"],
		"দ্ব": ["দ্ৱ"],
		"ধ্ব": ["ধ্ৱ"],
		"শ্ব": ["শ্ৱ"],
		"স্ব": ["স্ৱ"],
		"হ্ব": ["হ্ৱ"],
		"ংক": ["ঙ্ক"],
		"ংখ": ["ঙ্খ"],
		"ংগ": ["ঙ্গ"],
		"ংঘ": ["ঙ্ঘ"],
		"ঞা": ["য়াঁ"],
		"ৰ্ত": "ৰ্ত্ত",
		"ৰ্য": ["ৰ্য্য"],
        "ৰ্দ": "ৰ্দ্দ",
        "য়": ["য়"],
        "য়": ["য়"],
		"কট্ৰ": ["ক্ট্ৰ"],
		"ক্ট্ৰ": ["কট্ৰ"],
		"য়ো": "য়ো",
		"ৌ": "ৌ",
		"ো": "ো",
        "ড়": "ড়",
		"শ্ল’": ["শ্লো"],
        "ঢ়": "ঢ়",
        "ৰ্ম": "ৰ্ম্ম",
        "ৰ্ব": "ৰ্ব্ব",
		"্ব": "্ব‌",
		"‍্": ["‍্"],
		"ৎ": ["ত্"],
    },
    suggestion_replacement: {
			"ৰাজিখিনি": ["ৰাজি", "খিনি"],
			"সকল": ["লোক", "বোৰ"],
			"ফেণ্ড": ["ফ্ৰেণ্ড", "ফেন"],
			"তেদি": ["তেৰে", "তকদি"],
			"লৈকেও": ["লৈও", "লৈ", "লৈকো"],
			"ৰেহে": ["ৰহে", "হে", "ৰ", "ৰেই"],
			"কলৈ": ["লৈ", "লৈকে"],
			"দোষ": ["দুখ", "দূষ"],
			"ভাৱে": ["কৈ", "ভাবে"],
			"ুয়ে": ["ুৱে", "োৱে"],
			"োয়ে": ["ুৱে", "োৱে"],
			"ভাবে": "ভাৱে",
			"গাঁৱ": "গাৱঁ",
			"ক্ৰোট": "ক্ৰোৱেট",
			"ছাৰ্বিয়ান": "ছাৰ্ব",
			"পাৰা": ["পাৰ", "পৰা"],
			"জিম্বাবুৱান": "জিম্বাবুৱেন",
			"ডেনিছ": "ডেন",
			"বেলিজিয়ান": "বেলিজীয়েন",
			"বোয়ানছ": "বোয়েন্স",
			"অৰ্থাত": "অৰ্থাৎ",
			"জাতিয়": "জাতীয়",
			"মৰমীয়াল": "মৰমিয়াল",
			"কুৰু": "কৌৰ",
			"কৌৰ": "কুৰু",
			"পাণ্ড্যা": "পাণ্ডিয়া",
			"চকৰী": "চকৰি",
			"চকৰি": "চকৰী",
			"কূল": "কুল",
			"কুল": "কূল",
			"শুভাশীষ": "শুভাশিস",
			"দিক": "দিগ",
			"দিক্": "দিগ",
			"দিগ্": "দিগ",
			"গৰীৱ": "গৰিব",
			"গৰীব": "গৰিব",
			"হঁকো": "ওহঁক",
			"হঁকহে": "হেহঁক",
			"চোনহে": "হেচোন",
			"তোহে": "হেতো",
			"তোনহে": "হেতোন",
			"ওহে": "হে",
			"কোহে": "কেহে",
			"নাআগচ": "নাগচ",
			"নাআঁক": "নাক",
			"নাঁকি": "নাকি",
			"খোৱাবলৈ": "খুৱাবলৈ",
			"থল": "থ’ল",
			"শ্বহিদ": "চহিদ",
			"ছহীদ": "চহিদ",
			"অনাহিন্দু": "অহিন্দু",
			"অনাবড়ো": "অবড়ো",
			"অত্যান্তিক": "আত্যন্তিক",
			"গোৱালপৰীয়া": "গোৱালপাৰীয়া",
			"পাঠশলীয়া": "পাঠশালীয়া",
			"বাইহটীয়া": "বাইহাটীয়া",
			"খানাপৰীয়া": "খানাপাৰীয়া",
			"হাৰিভংগীয়া": "হাৰিভাংগীয়া",
			"মাখিবহীয়া": "মাখিবাহীয়া",
			"শালমৰীয়া": "শালমাৰীয়া",
			"বিলাসীপৰীয়া": "বিলাসীপাৰীয়া",
			"লক্ষ্যণীয়": "লক্ষণীয়",
			"সামৰ্থবান": "সামৰ্থ্যৱান",
			"নিঃস্বাৰ্থপৰ": "অস্বাৰ্থপৰ",
			"চনিয়া": "চনীয়া",
			"উৱা": "ওৱা",
			"সৰ্বস্ৰান্ত": "সৰ্বস্বান্ত",
			"কাঠামো": "কাঠাম",
			"খিৰিকি": "খিৰিকী",
			"খিৰীকি": "খিৰিকী",
			"খিৰীকী": "খিৰিকী",
			"খিড়িকি": "খিৰিকী",
			"খিড়ীকী": "খিৰিকী",
			"লিগিৰি": "লিগিৰী",
			"লিগীৰি": "লিগিৰী",
			"লিগীৰী": "লিগিৰী",
			"ডাকিনি": "ডাকিনী",
			"পখিলি": "পখিলী",
			"পখীলি": "পখিলী",
			"পখীলী": "পখিলী",
			"আন্তঃ": "আন্তৰ্",
			"আন্ত": "আন্তঃ",
			"আন্তৰ্": "আন্তঃ",
			"তৎ": "তজ্জ",
			"শৈৱপন্থা": "শৈৱপন্থ",
			"বৈষ্ণৱপন্থা": "বৈষ্ণৱপন্থ",
			"সচৰাচৰভাৱে": "সচৰাচৰ",
			"পশ্ছাদ": "পশ্চাদ",
			"পশ্চাৎ": "পশ্চাদ",
			"পচ্ছাদ": "পশ্চাদ",
			"পশ্চাদ": "পশ্চাৎ",
			"ক”লে": "ক’লে",
			"সঁকিয়া": "সকীয়া",
			"হ’য়": "হয়",
			"ডবা": "দবা",
			"কৰবা": "ক’ৰবা",
			"কিৰিলি": "কিৰীলি",
			"কিৰিলী": "কিৰীলি",
			"েয়ে": "ে",
			"ূয়ে": "ূৱে",
			"ৌয়ে": "ৌৱে",
			"ক্ষোভিত": "ক্ষুভিত",
			"শিৰা": "সিৰা",
			"এইয়া": "এয়া",
			"তিহঁত": "তাহঁত",
			"তাহাঁত": "তাহঁত",
			"সিয়াক": "তাক",
			"ওখভাৱে": "ওখকৈ",
			"ওখৰূপে": "ওখকৈ",
			"চাবিকাঠি": "চাবিকাঠী",
			"আগবাঢ়": "আগ",
			"পুৰুধা": "পুৰোধা",
			"পেজ": "পেইজ",
			"অসূৰ্যস্পৰ্শা": "অসূৰ্যম্পশ্যা",
			"তেজোদীপ্ত": "তেজোদ্দীপ্ত",
			"প্ৰতিদ্বন্দিতা": "প্ৰতিদ্বন্দ্বিতা",
			"প্ৰতিদন্দিতা": "প্ৰতিদ্বন্দ্বিতা",
			"প্ৰতিদন্দ্বিতা": "প্ৰতিদ্বন্দ্বিতা",
			"উৎকৰ্ষতা": "উৎকৰ্ষ",
			"আশ্চৰ্যচকিত": "আশ্চৰ্যান্বিত",
			"আশ্বৰ্য": "আশ্চৰ্য",
			"আশ্চয্য": "আশ্চৰ্য",
			"আশ্চয": "আশ্চৰ্য",
			"আশ্বয্য": "আশ্চৰ্য",
			"কেন্দ্ৰীয়শাসিত": "কেন্দ্ৰশাসিত",
			"আন্তগাঠনি": "আন্তঃগাঁথনি",
			"আন্ত:গাঁঠনি": "আন্তঃগাঁথনি",
			"আন্তগাঁঠনি": "আন্তঃগাঁথনি",
			"আন্তঃগাঁঠনি": "আন্তঃগাঁথনি",
			"আন্তগাথনি": "আন্তঃগাঁথনি",
			"আন্তগাঁথনি": "আন্তঃগাঁথনি",
			"আন্তঃগাথনি": "আন্তঃগাঁথনি",
			"আন্তঃগাথনী": "আন্তঃগাঁথনি",
			"তুচ্চ": "তুচ্ছ",
			"তাচ্চিল্য": "তাচ্ছিল্য",
			"তাচিল্য": "তাচ্ছিল্য",
			"তুচ্চ-তাচ্চিল্য": "তুচ্ছ-তাচ্ছিল্য",
			"দম্পতি": "দম্পতী",
			"দম্পত্তী": "দম্পতী",
			"দম্পত্তি": "দম্পতী",
			"তীৰ্যক": "তিৰ্যক",
			"মুহুৰ্ত": "মুহূৰ্ত",
			"মূহুৰ্ত": "মুহূৰ্ত",
			"মূহূৰ্ত": "মুহূৰ্ত",
			"জীৱি": "জীৱী",
			"জিৱি": "জীৱী",
			"জিৱী": "জীৱী",
			"জিৱীতা": "জীৱিতা",
			"জীৱীতা": "জীৱিতা",
			"ওতঃপ্ৰোত": "ওতপ্ৰোত",
			"পিটকলি": "পিতকলি",
			"সাহন": "সাহোন",
			"মতিছন্ন": "মতিচ্ছন্ন",
			"কুঠাৰঘাত": "কুঠাৰাঘাত",
			"কুঠাৰঘাট": "কুঠাৰাঘাত",
			"তৎক্ষণাৎ": "তৎক্ষণাত",
			"গোঁহাঞি": "গোহাঞি",
			"গোহাঁঞি": "গোহাঞি",
			"গোহাঞিঁ": "গোহাঞি",
			"নিৰ্ভিক": "নিৰ্ভীক",
			"দৰ্কাৰ": "দৰকাৰ",
			"নূন্য": "ন্যূন",
			"দুৰ্": "দূৰ্",
			"দূৰ্": "দুৰ্",
			"দুৰ": "দূৰ",
			"দূৰ": "দুৰ",
			"উদ্দেশ্যেৰে": "উদ্দেশ্যে",
			"মুৰ": "মূৰ",
			"মেলভগীয়া": "মেলডগীয়া",
			"ন্যুন": "ন্যূন",
			"বৰ্ড": "ব’ৰ্ড",
			"উৱে": "ৱে",
			"ওৱে": "ৱে",
			"ওঁৱে": "ৱেঁ",
			"জেষ্ঠ": "জ্যেষ্ঠ",
			"জেষ্ঠ্য": "জ্যেষ্ঠ",
			"জ্যষ্ঠ": "জ্যেষ্ঠ",
			"হতাশ": "হতাশা",
			"মূখ্য": "মুখ্য",
			"মূৰ": "মুৰ",
			"মূৱা": "মুৱা",
			"হেৰুৱাৰ": "হেৰুওৱাৰ",
			"হলে": "হ’লে",
			"চোষ্য": "চুষ্য",
			"অত্যাধিক": "অত্যধিক",
			"চুজা": "সোজা",
			"সুজা": "সোজা",
			"তদজনিত": "তজ্জনিত",
			"সদ্য": "সদ্যো",
			"ফেল": "ফেইল",
			"অতঃএব": "অতএব",
			"আপাতঃ": "আপাত",
			"নভঃস্তল": "নভস্তল",
			"অন্তঃ": "অন্তৰ্",
			"পুনঃ": "পুনৰ্",
			"সদ্যঃস": "সদ্যস",
			"সদ্যোস": "সদ্যস",
			"সদ্যপ": "সদ্যঃপ",
			"সদ্যোপ": "সদ্যঃপ",
			"সদ্যব": "সদ্যোব",
			"সদ্যঃব": "সদ্যোব",
			"সদ্যম": "সদ্যোম",
			"সদ্যঃম": "সদ্যোম",
			"সদ্যজ": "সদ্যোজ",
			"সদ্যঃজ": "সদ্যোজ",
			"শিৰঃভ": "শিৰোভ",
			"পুনঃজ": "পুনৰ্জ",
			"শিৰচ্ছ": "শিৰশ্ছ",
			"শিৰঃছ": "শিৰশ্ছ",
			"নিঃচ": "নিশ্চ",
			"তথাপিও": "তথাপি",
			"কদাপিও": "কদাপি",
			"ওপৰিও": "উপৰি",
			"উপৰিও": "উপৰি",
			"ক্ষীপ্ৰ": "ক্ষিপ্ৰ",
			"বৈচিত্ৰ": "বৈচিত্ৰ্য",
			"বিচিত্ৰ্য": "বৈচিত্ৰ্য",
			"আসোঁৱাহ‌": "আসোঁৱাহ",
			"আঁসোঁৱাহ‌": "আসোঁৱাহ",
			"আঁসোৱাহ‌": "আসোঁৱাহ",
			"হাঁহাকাৰ‌": "হাহাকাৰ‌",
			"হাঁহাঁকাৰ‌": "হাহাকাৰ‌",
			"হাহাঁকাৰ‌": "হাহাকাৰ‌",
			"ৰাজিবোৰ": "ৰাজি",
			"ৰাজিবিলাক": "ৰাজি",
			"আগবঢ়া": "আগ",
			"কম্পুটাৰ": "কম্পিউটাৰ",
			"ইহুদী": "ইহুদি",
			"পাৰম্পৰিক": "পৰম্পৰাগত",
			"আন্তৰাষ্ট্ৰীয়": "আন্তঃৰাষ্ট্ৰীয়",
			"আন্তঃৰ্জাতিক": "আন্তৰ্জাতিক",
			"বাহুল্যতা": "বাহুল্য",
			"আভ্যন্তৰ": "অভ্যন্তৰ",
			"শীষ": "শিস",
			"শীশ": "শিস",
			"শিষ": "শিস",
			"দুঃচিন্তা": "দুশ্চিন্তা",
			"দুচিন্তা": "দুশ্চিন্তা",
			"শাৰিৰীক": "শাৰীৰিক",
			"শাৰিৰিক": "শাৰীৰিক",
			"প্ৰৱিত্ৰ": "পবিত্ৰ",
			"পৱিত্ৰ": "পবিত্ৰ",
			"দাংশ": "দংশ",
			"য়ত্ব": "য়ত্ত",
			"জীবি": "জীৱী",
			"কাঠি": "কাঠী",
			"নুন্যতম": "ন্যূনতম",
			"উৎফুল্লিত": "উৎফুল্ল",
			"যকৃত": "যকৃৎ",
			"সৌজন্যতা": "সৌজন্য",
			"পাট": "পাত",
			"পাত": "পাট",
			"পষ্ট": "প’ষ্ট",
			"অট": "অট’",
			"সীস": "শীহ",
			"হব": "হ’ব",
			"লব": "ল’ব",
			"গল": "গ’ল",
			"থব": "থ’ব",
			"বব": "ব’ব",
			"মিতা": "মিত্ব",
			"মিত্ব": "মিতা",
			"ভীৰ": "ভিৰ",
			"ৰাষ্টা": "ৰাস্তা",
			"উত": "উৎ",
			"ব্যংগ": "ব্যংগ্য",
			"ব্যংগোক্তি": "ব্যংগ্যোক্তি",
			"ইয়ে": "য়ে",
			"কাওবাও": "কাউ-বাউ",
			"কাও-বাও": "কাউ-বাউ",
			"সম্মান": "সন্মান",
			"ভাতৃত্ব": "ভ্ৰাতৃত্ব",
			"ঐক্যতা": "ঐক্য",
			"অনৈক্যতা": "অনৈক্য",
			"ভিছুৱেল": "ভিজুৱেল",
			"শুন্য": "শূন্য",
			"শুণ্য": "শূন্য",
			"শূণ্য": "শূন্য",
			"নমশুদ্ৰ": "নমঃশূদ্ৰ",
			"নমঃশুদ্ৰ": "নমঃশূদ্ৰ",
			"টেষ্টষ্টেৰন": "টেষ্ট’ষ্টেৰ’ন",
			"টেষ্টষ্টেৰোন": "টেষ্ট’ষ্টেৰ’ন",
			"টেষ্টোষ্টেৰোন": "টেষ্ট’ষ্টেৰ’ন",
			"টেষ্টোষ্টেৰ’ন": "টেষ্ট’ষ্টেৰ’ন",
			"দুভাগ্য": "দুৰ্ভাগ্য",
			"আনুসংগিক": "আনুষংগিক",
			"প্ৰত্যাখাত": "প্ৰত্যাখ্যাত",
			"গোঁসা": "গোসাঁ",
			"তেও": "তেওঁ",
			"এও": "এওঁ",
			"গোঁহা": "গোহাঁ",
			"স্যাৎ": "সাৎ",
			"মইও": "ময়ো",
			"এক": "এ",
			"দুই": "দু",
			"ছয়": "ছ",
			"তাইয়ো": "তায়ো",
			"সিয়ো": "সিও",
			"আঁকোৰগোজ": "আঁকোৰগোঁজ",
			"সম্ৰাজ্য": "সাম্ৰাজ্য",
			"দোষণীয়": "দূষণীয়",
			"মণিষী": "মনীষী",
			"পূজাৰীণি": "পূজাৰিণী",
			"পূজাৰীণী": "পূজাৰিণী",
			"লাগতীয়াল": "লাগতিয়াল",
			"ভেৰুণীয়া": "ভেৰোনীয়া",
			"বুৰপোৱা": "বুৰপোআ",
			"বৰ্হিপ্ৰকাশ": "বহিঃপ্ৰকাশ",
			"ফেংছুই": "ফেংচ্যুই",
			"ফেংচুই": "ফেংচ্যুই",
			"কৰিডৰ": "কৰিড’ৰ",
			"উপঙি": "ওপঙি",
			"পৈত্তৃক": "পৈত্তিক",
			"বাইচেপ": "বাইচেপ্স",
			"স্বত্বেও": "সত্ত্বেও",
			"উৰ্ত্তীণ": "উত্তীৰ্ণ",
			"আগবাঢ়ি": "আগ বাঢ়ি",
			"মাইক্ৰ": "মাইক্ৰ’",
			"মাইক্ৰ'": "মাইক্ৰ’",
			"পোনচাটে": "পোনচাতে",
			"প্ৰৱাহমান": "প্ৰৱহমান",
			"ঠুটনি": "ঠোঁটনি",
			"বৌদ্বিক": "বৌদ্ধিক",
			"উজ্বলি": "উজলি",
			"মাটিকাদুৰি": "মাটিকাঁদুৰি",
			"চাটজিপিট": "চ্চেটজিপিট",
			"একোটি": "এককোটি",
			"দুকোটি": "দুইকোটি",
			"জোঁকাৰ": "জোকাৰ",
			"ছকোটি": "ছয়কোটি",
			"এলাখ": "একলাখ",
			"দুলাখ": "দুইলাখ",
			"ছলাখ": "ছয়লাখ",
			"জাত্যাভি": "জাত্যভি",
			"ভেকো-ভাওনা": "ভেকোভাওনা",
			"ভেকুভাওনা": "ভেকোভাওনা",
			"ভেঁকোভাওনা": "ভেকোভাওনা",
			"ভেঁকুভাওনা": "ভেকোভাওনা",
			"হুলস্থুল": "হুলস্থূল",
			"সাহাৰ্য": "সাহায্য",
			"সাহাৰ্য্য": "সাহায্য",
			"সহাৰ্য্য": "সাহায্য",
			"সহাৰ্য": "সাহায্য",
			"সহায": "সাহায্য",
			"ইকছিষ্টেম": "ইক’ছিষ্টেম",
			"মফঃস্বল": "মফচল",
			"ভাৰসাম্যতা": "ভাৰসাম্য",
			"গাঠনি": "গাঁথনি",
			"সৰ্বত্ৰত": "সৰ্বত্ৰে",
			"শৱদেহ": "শৱ",
			"উপ": "ঔপ",
			"ভেঁকো": "ভেকো",
			"গাঁথা": "গাথা",
			"জিম": "জম",
			"ভন্টি": "ভণ্টী",
			"ভন্তী": "ভণ্টী",
			"খুওব": "খুউব",
			"শুইন": "শূইন",
			"নিদ": "নিৰ্দ",
			"দৰ্মহা": "দৰমহা",
			"চৰ্কাৰ": "চৰকাৰ",
			"নিৰ্লজ্জ্য": " নিৰ্লজ্জ",
			"নিলজ্জ্য": " নিৰ্লজ্জ",
			"নিলজ্জ": " নিৰ্লজ্জ",
			"নিল্লজ্জ": " নিৰ্লজ্জ",
			"নিল্লজ": " নিৰ্লজ্জ",
			"কিম্বদন্তী": "কিম্বদন্তি",
			"কিংবদন্তী": "কিংবদন্তি",
			"প্ৰতীম": "প্ৰতিম",
			"হাঁহাকাৰ": "হাহাকাৰ",
			"হাঁহাঁকাৰ": "হাহাকাৰ",
			"হাহাঁকাৰ": "হাহাকাৰ",
			"সঁচাসচি": "সঁচাসঁচি",
			"ধৰ্মালম্বী": "ধৰ্মাৱলম্বী",
			"জুলুঙা": "জোলোঙা",
			"কাউনচে": "কাউন্সে",
			"কাউনছে": "কাউন্সে",
			"নগুৰ-নাকতি": "নগুৰ-নাগতি",
			"বিলিয়": "বিলীয়",
			"গৌৰাৱাম্বিত": "গৌৰৱান্বিত",
			"গৌৰাৱান্বিত": "গৌৰৱান্বিত",
			"গৌৰাম্বিত": "গৌৰৱান্বিত",
			"নিষ্কাষণ": "নিষ্কাশন",
			"নিষ্কাষন": "নিষ্কাশন",
			"সহৃদয়ৱান": "হৃদয়ৱান",
			"চিকিউৰিটি": "ছিকিউৰিটি",
			"চিকিউৰিটী": "ছিকিউৰিটি",
			"ছিকিউৰিটী": "ছিকিউৰিটি",
			"পোছমটেম": "প’ষ্টম’ৰ্টেম",
			"পষ্টমটেম": "প’ষ্টম’ৰ্টেম",
			"পষ্টমৰ্টেম": "প’ষ্টম’ৰ্টেম",
			"পোষ্টমৰ্টেম": "প’ষ্টম’ৰ্টেম",
			"পষ্টম’ৰ্টেম": "প’ষ্টম’ৰ্টেম",
			"প’ষ্টমৰ্টেম": "প’ষ্টম’ৰ্টেম",
			"প’ষ্টমোৰ্টেম": "প’ষ্টম’ৰ্টেম",
			"পোষ্টম’ৰ্টেম": "প’ষ্টম’ৰ্টেম",
			"গড়কাপ্টানী": "গড়কাপ্তানি",
			"গড়কপ্টানী": "গড়কাপ্তানি",
			"গড়কাপ্টানি": "গড়কাপ্তানি",
			"গড়কপ্টানি": "গড়কাপ্তানি",
			"গড়কাপ্তানী": "গড়কাপ্তানি",
			"গড়কপ্তানী": "গড়কাপ্তানি",
			"কেৰীবেগ": "কেৰিবেগ",
			"ঊৰ্ধ্বতালি": "উদ্ধতালি",
			"উৰ্ধতালি": "উদ্ধতালি",
			"ঊৰ্ধতালি": "উদ্ধতালি",
			"উৰ্দ্ধতালি": "উদ্ধতালি",
			"ঊৰ্দ্ধতালি": "উদ্ধতালি",
			"যৌৱনুদীপ্ত": "যৌৱনোদ্দীপ্ত",
			"কাৰ্চিং-কাৰদাং": "কাৰ্চিং-কাৰ্তাক",
			"কাৰ্চিং-কাৰতাক": "কাৰ্চিং-কাৰ্তাক",
			"সন্ম": "সন্মা",
			"কিন্ত": "কিন্তু",
			"কিনতু": "কিন্তু",
			"মৰ্য": "মৰ্যা",
			"মৰ্য্যদা": "মৰ্যাদা",
			"মোন": "ম’ন",
			"ব্যাম": "ব্যায়াম",
			"নেনো": "নেন’",
			"বুদ্ধি": "বোধি",
			"যঁট": "জঁট",
			"জট": "জঁট",
			"কোৰ": "কুৰ",
			"ঘাট": "ঘাত",
			"ঘাত": "ঘাট",
			"বেতাঘাত": "বেত্ৰাঘাত",
			"কুৰ": "কোৰ",
			"মোহম্মদ": "মহম্মদ",
			"মুহাম্মদ": "মহম্মদ",
			"মহমদ": "মহম্মদ",
			"হানজা": "হুনজা",
			"কিঃমিঃ": "কি:মি:",
			"মিঃমিঃ": "মি:মি:",
			"মিঃ": "মি:",
			"কেঃজিঃ": "কে:জি:",
			"বিঃদ্ৰঃ": "বি:দ্ৰ:",
			"খ্ৰীঃ": "খ্ৰী:",
			"পূঃ": "পূ:",
			"খ্ৰীঃপূঃ": "খ্ৰী:পূ:",
			"বিদ্ৰ": "বি:দ্ৰ:",
			"অন্ত": "আন্তঃ",
			"বহি": "বহিঃ",
			"সহঃ": "সহ:",
			"সিধান্ত": "সিদ্ধান্ত",
			"যোৰ": "জোৰ",
			"জোৰ": "যোৰ",
			"যোৰা": "জোৰা",
			"ফাঁন্দ": "ফান্দ",
			"হাপানি": "হাঁপানী",
			"হাঁপানি": "হাঁপানী",
			"হাওফাও": "হাঁওফাঁও",
			"হাওফাওঁ": "হাঁওফাঁও",
			"হাওঁফাও": "হাঁওফাঁও",
			"হাওঁফাওঁ": "হাঁওফাঁও",
			"কতৃ": "কৰ্তৃ",
			"চন্ন": "চ্ছন্ন",
			"ছন্ন": "চ্ছন্ন",
			"চ্চন্ন": "চ্ছন্ন",
			"বস্ত": "বস্তু",
			"সৌহাদ্য": "সৌহাৰ্দ্য",
			"সৌহাৰ্দ": "সৌহাৰ্দ্য",
			"নাকতি": "নাগতি",
			"থেৰা": "থেৰ",
			"সচা": "সঁচা",
			"উখ": "ওখ",
			"উফ": "ওফ",
			"উভ": "ওভ",
			"উল": "ওল",
			"উভো": "ওভো",
			"উলো": "ওলো",
			"উম": "ওম",
			"উন্দো": "ওন্দো",
			"ওভ": "উভ",
			"ওল": "উল",
			"ওপ": "উপ",
			"উপৰ": "ওপৰ",
			"ওক": "উক",
			"ইঞ্চ": "ইন্স",
			"লৱ": "ল’ব",
			"ৰৱ": "ৰ’ব",
			"ৰব": "ৰৱ",
			"তত": "তৎ",
			"তস": "ৎস",
			"সান্তনা": "সান্ত্বনা",
			"শান্তনা": "সান্ত্বনা",
			"শান্ত্বনা": "সান্ত্বনা",
			"সান্ত": "শান্ত",
			"কাংখা": "কাংক্ষা",
			"কাংখী": "কাংক্ষী",
			"কাংশী": "কাংক্ষী",
			"শোভা": "শুভা",
			"ম্যাদি": "ম্যাদী",
			"কোবাল্ট": "ক’বাল্ট",
			"চিৰাল": "ছিঁৰাল",
			"নিৰ": "নীৰ",
			"শল": "শ’ল",
			"ীত্ব": "িত্ব",
			"ীতা": "িতা",
			"খুচ": "খুঁচ",
			"খোচ": "খোঁচ",
			"স্বত": "স্বত্ব",
			"স্বত্ত্ব": "স্বত্ব",
			"চশমা": "চচমা",
			"চছমা": "চচমা",
			"ছশমা": "চচমা",
			"ছচমা": "চচমা",
			"ছছমা": "চচমা",
			"চিনি": "চেনি",
			"ত্বাব": "ত্ত্বাৱ",
			"চেলচিয়াচ": "চেলছিয়াছ",
			"চেলচিয়াছ": "চেলছিয়াছ",
			"চেলছিয়াচ": "চেলছিয়াছ",
			"ছেলচিয়াচ": "চেলছিয়াছ",
			"ছেলচিয়াছ": "চেলছিয়াছ",
			"ছেলছিয়াচ": "চেলছিয়াছ",
			"ছেলছিয়াছ": "চেলছিয়াছ",
			"গাম্ভীৰ্যতা": "গাম্ভীৰ্য",
			"খুতিনাতি": "খুঁটি-নাটি",
			"খুতি-নাতি": "খুঁটি-নাটি",
			"খুঁতিনাতি": "খুঁটি-নাটি",
			"খুঁতি-নাতি": "খুঁটি-নাটি",
			"খুটিনাতি": "খুঁটি-নাটি",
			"খুঁটিনাতি": "খুঁটি-নাটি",
			"খুটিনাটি": "খুঁটি-নাটি",
			"খুটি-নাটি": "খুঁটি-নাটি",
			"কাবাডী": "কাবাদী",
			"চাওতালি": "চাওঁতালী",
			"চাওতালী": "চাওঁতালী",
			"ফৰমেলিন": "ফৰ্মেলিন",
			"বাৰ্থদে": "বাৰ্থডে",
			"মুটামুটি": "মোটামুটি",
			"মোটামোটি": "মোটামুটি",
			"এঞ্জেলছ": "এঞ্জেলেছ",
			"ভাগবটোৱাৰা": "ভাগবাটোৱাৰা",
			"ভাগবঁটোৱাৰা": "ভাগবাটোৱাৰা",
			"ভাগবাঁটোৱাৰা": "ভাগবাটোৱাৰা",
			"ভাগবাটোৱাৰ": "ভাগবাটোৱাৰা",
			"বাপুতিসাহোন": "বাপতিসাহোন",
			"বাপোতিসাহোন": "বাপতিসাহোন",
			"পূজি": "পুঁজি", 
			"পূঁজি": "পুঁজি",
			"পুজি": "পুঁজি",
			"পঁজি": "পুঁজি",
			"পোৰ্ট": "প’ৰ্ট",
			"দগমগ": "ডগমগ",
			"ট্ৰেজেদী": "ট্ৰেজেডি",
			"ট্ৰেজেদি": "ট্ৰেজেডি",
			"হস্পিতাল": "হস্পিটেল",
			"হস্পতাল": "হস্পিটেল",
			"হাস্পতাল": "হস্পিটেল",
			"ভড়াল": "ভঁৰাল",
			"ভৰাল": "ভঁৰাল",
			"বাক": "বাগ",
			"বাগ": "বাক",
			"চত্ৰ": "ছত্ৰ",
			"স্বতস্ফুত": "স্বতঃস্ফূৰ্ত",
			"স্বতস্ফূত": "স্বতঃস্ফূৰ্ত",
			"স্বতস্ফুৰ্ত": "স্বতঃস্ফূৰ্ত",
			"স্বতস্ফূৰ্ত": "স্বতঃস্ফূৰ্ত",
			"পৰিস্ফূট": "পৰিস্ফুট",
			"অবয়ব": "অৱয়ব",
			"অবয়ৱ": "অৱয়ব",
			"অৱয়ৱ": "অৱয়ব",
			"উৰ্মি": "ঊৰ্মি",
			"বৈধ্য": "বধ্য",
			"বধ্য": "বৈধ",
			"সুৰুয": "সূৰুয",
			"সুৰুজ": "সূৰুয",
			"সূৰুজ": "সূৰুয",
			"বুভুক্ষ": "বুভুক্ষু",
			"বুভূক্ষু": "বুভুক্ষু",
			"সলাল": "শলাল",
			"শিৰোনামা": "শিৰোনাম",
			"শিৰঃনাম": "শিৰোনাম",
			"শিৰঃনামা": "শিৰোনাম",
			"আমছু": "এমছু",
			"আবছু": "এবছু",
			"বিপৰীত্য": "বৈপৰীত্য",
			"বায়ো": "বায়’",
			"স্তুপ": "স্তূপ",
			"স্তপ": "স্তূপ",
			"তেঁও": "তেওঁ",
			"পাঁও": "পাওঁ",
			"াঁও": "াওঁ",
			"ৰূদ্ৰ": "ৰুদ্ৰ",
			"হাতী": "হাটী",
			"ভ্ৰুণ": "ভ্ৰূণ",
			"সামন্ত্ৰ": "সামন্ত",
			"উৰফে": "ওৰফে",
			"প্ৰায়চিত্ত": "প্ৰায়শ্চিত্ত",
			"ঠোট": "ঠোঁট",
			"ঠুট": "ঠোঁট",
			"ঠুঁট": "ঠোঁট",
			"থোঁট": "ঠোঁট",
			"প্ৰয়": "প্ৰায়",
			"পৌৰহিত্য": "পৌৰোহিত্য",
			"ক্ক": "ক্ব",
			"ক্ব": "ক্ক",
			"ধৰ্য": "ধৈৰ্য",
			"ুৎ": "োৎ",
			"ুপল": "োপল",
			"ুৎপল": "োৎপল",
			"প্ৰত্যাপন": "প্ৰত্যায়ন",
			"সেন্দুৰ": "সেন্দূৰ",
			"লদ্ধ": "লব্ধ",
			"ককাল": "কঁকাল",
			"ভূক্ত": "ভুক্ত",
			"ভুগী": "ভোগী",
			"ভূগী": "ভোগী",
			"চত্ৰী": "চ্ছত্ৰী",
			"ছত্ৰী": "চ্ছত্ৰী",
			"তুষ্টি": "তুষ্ট",
			"নিৰ্গত": "নিৰ্গমন",
			"নিৰ্বোধিতা": "নিৰ্বুধিতা",
			"চলচ্ছিত্ৰ": "চলচ্চিত্ৰ",
			"চলচিত্ৰ": "চলচ্চিত্ৰ",
			"চল্লচিত্ৰ": "চলচ্চিত্ৰ",
			"চলছিত্ৰ": "চলচ্চিত্ৰ",
			"চোৱা": "ছোৱা",
			"হৃদ": "হৃৎ",
			"হৃৎ": "হৃদ",
			"অৰ্দ্ধ": "অৰ্ধ",
			"অৰ্ঘ": "অৰ্ঘ্য",
			"দৈৰ্ঘ": "দৈৰ্ঘ্য",
			"অৰ্ঘ্য": "অৰ্ঘ",
			"মহাৰ্ঘ": "মহাৰ্ঘ্য",
			"থেৰো-গেৰো": "থেৰোগেঁৰো",
			"থেৰোগেৰো": "থেৰোগেঁৰো",
			"থেঁৰোগেঁৰো": "থেৰোগেঁৰো",
			"থেঁৰো-গেঁৰো": "থেৰোগেঁৰো",
			"ৱান": "মান",
			"মান": "ৱান",
			"বান": "ৱান",
			"ৱন্ত": "মন্ত",
			"মন্ত": "ৱন্ত",
			"মন্তী": "মতী",
			"ফফৰা": "ফপৰা",
			"ফাফৰ": "ফাপৰ",
			"ৱয়ৱ": "ৱয়ব",
			"বয়ৱ": "ৱয়ব",
			"বয়ব": "ৱয়ব",
			"ঊৰুমি": "উৰুমি",
			"মুল্য": "মূল্য",
			"শেব্দ": "শব্দে",
			"দূৰ্গ": "দুৰ্গ",
			"দূৰ্গা": "দুৰ্গা",
			"বিস্তৃৰ্ণ": "বিস্তীৰ্ণ",
			"বিস্তিৰ্ণ": "বিস্তীৰ্ণ",
			"নিকছ": "নিক্স",
			"ব্যৱ": "ব্যাৱ",
			"ঐক্য": "ঐক",
			"ঐক্যমত": "ঐকমত্য",
			"কাঁহুদি": "কাহুঁদি",
			"কেৰা": "কেঁৰা",
			"পছন্দ": "পচন্দ",
			"ব্যাখা": "ব্যাখ্যা",
			"ব্যখা": "ব্যাখ্যা",
			"বাখ্যা": "ব্যাখ্যা",
			"ব্যাখ্য": "ব্যাখ্যা",
			"সমো": "সমু",
			"ৱস্ত": "বস্ত",
			"সৰ্বপল্লী": "সৰ্বেপল্লী",
			"গ্ৰাম্য": "গ্ৰাম",
			"তিয়ঁহ": "তিঁয়হ",
			"তিয়হ": "তিঁয়হ",
			"কাচি": "কাঁচি",
			"কাঁচি": "কাচি",
			"আভজা": "অভঁজা",
			"অভজা": "অভঁজা",
			"আঁভজা": "অভঁজা",
			"অঁভজা": "অভঁজা",
			"আভঁজা": "অভঁজা",
			"আভঁজুৱা": "অভঁজুৱা",
			"আভজুৱা": "অভঁজুৱা",
			"অভজুৱা": "অভঁজুৱা",
			"আঁভজুৱা": "অভঁজুৱা",
			"অঁভজুৱা": "অভঁজুৱা",
			"ৰোৱতী": "ৰোৱঁতী",
			"ৰোঁৱতী": "ৰোৱঁতী",
			"ৰুৱঁতী": "ৰোৱঁতী",
			"ৰুঁৱতী": "ৰোৱঁতী",
			"ধোৱতী": "ধোৱঁতী",
			"ধোঁৱতী": "ধোৱঁতী",
			"ধুৱঁতী": "ধোৱঁতী",
			"ধুঁৱতী": "ধোৱঁতী",
			"ওৰীয়া": "ৱৰীয়া",
			"হাড়": "হাৰ",
			"ছেদ": "চ্ছেদ",
			"ফই": "ফয়",
			"ফয়": "ফই",
			"হন": "হণ",
			"হণ": "হন",
			"পন": "পণ",
			"পণ": "পন",
			"ধূতি": "ধুতি",
			"যাঞ্ছা": "যাচ্ঞা",
			"একছত্ৰী": "একচ্ছত্ৰী",
			"নুক্ৰম": "ণুক্ৰম",
			"নিৰোদ": "নিৰুদ",
			"বিছিন্ন": "বিচ্ছিন্ন",
			"শিৰছেদ": "শিৰশ্ছেদ",
			"শিৰঃছেদ": "শিৰশ্ছেদ",
			"শিৰচ্ছেদ": "শিৰশ্ছেদ",
			"শিৰঃচ্ছেদ": "শিৰশ্ছেদ",
			"প্ৰতিনিধিমূলক": "প্ৰতিনিধিত্বমূলক",
			"কাৰীসূত্ৰে": "কাৰসূত্ৰে",
			"বিভ্ৰান্তকৰ": "বিভ্ৰান্তিকৰ",
			"বিভ্ৰান্তিকাৰী": "বিভ্ৰান্তকাৰী",
			"কাঠিন্যতা": "কাঠিন্য",
			"সিঁচৰিত": "সিঁচৰতি",
			"শোগৰা": "সোগোৰা",
			"শোগোৰা": "সোগোৰা",
			"সোগৰা": "সোগোৰা",
			"বীতস্পৃহা": "বীতস্পৃহ",
			"বীতশ্ৰদ্ধা": "বীতশ্ৰদ্ধ",
			"বীতনিদ্ৰা": "বীতনিদ্ৰ",
			"সশ্ৰদ্ধা": "সশ্ৰদ্ধ",
			"সচেষ্টা": "সচেষ্ট",
			"আনুভূমিক": "অনুভূমিক",
			"সামঞ্জস্যতা": "সামঞ্জস্য",
			"সাদৃশ্যতা": "সাদৃশ্য",
			"ধিক্যতা": "ধিক্য",
			"বিপদজ্জনক": "বিপজ্জনক",
			"স্হ": "স্থ",
			"উতপ্ত": "উত্তপ্ত",
			"ভূৱা": "ভুৱা",
			"উদগিৰণ": "উদগীৰণ",
			"উদগিৰন": "উদগীৰণ",
			"উদগীৰন": "উদগীৰণ",
			"সন্ধিগ্ধ": "সন্দিগ্ধ",
			"সুমোৱা": "সুমুওৱা",
			"মাদ্ৰক": "মাদক",
			"দৈতকণ্ঠ": "দ্বৈতকণ্ঠ",
			"দৈত্যকণ্ঠ": "দ্বৈতকণ্ঠ",
			"আৰ্জ": "অৰ্জ",
			"স্বাচন্দ্য": "স্বাচ্ছন্দ্য",
			"স্বাছন্দ্য": "স্বাচ্ছন্দ্য",
			"স্বাচ্ছন্দ": "স্বাচ্ছন্দ্য",
			"স্বচ্ছন্দ্য": "স্বাচ্ছন্দ্য",
			"্যতা": "্য",
			"স্বাচ্ছন্দ্যতা": "স্বাচ্ছন্দ্য",
			"পৌৰুষতা": "পৌৰুষ",
			"পৌৰুষত্ব": "পৌৰুষ",
			"অংশীভূক্ত": "অংশীভূত",
			"অংশীভুক্ত": "অংশীভূত",
			"বহিৰ্ভুক্ত": "বহিৰ্ভূত",
			"বহিৰ্ভূক্ত": "বহিৰ্ভূত",
			"বৃহৎৰূপে": "বৃহদৰূপে",
			"বৃহৎৰূপী": "বৃহদৰূপী",
			"এক্সচেঞ্জ": "এক্সেঞ্জ",
			"ধপাত": "ধঁপাত",
			"সূলভ": "সুলভ",
			"দূৰ্লভ": "দুৰ্লভ",
			"ভূৱন": "ভুৱন",
			"মুল": "মূল",
			"বাদিনী": "বাদিকা",
			"পৰিস্ৰাৱণ": "পৰিস্ৰৱণ",
			"ৰেষ্টুৰাঁ": "ৰেষ্টোৰাঁ",
			"ৰেষ্টুঁৰা": "ৰেষ্টোৰাঁ",
			"ৰেষ্টুৰা": "ৰেষ্টোৰাঁ",
			"ৰেস্তোৰাঁ": "ৰেষ্টোৰাঁ",
			"ৰেষ্টুৰেণ্ট": "ৰেষ্টোৰাঁ",
			"পাউ": "পাও",
			"পাউদাৰ": "পাওডাৰ",
			"পাওদাৰ": "পাওডাৰ",
			"ভৱিষৎ": "ভৱিষ্যৎ",
			"ভৱিষ্যদ্ধাণী": "ভৱিষ্যদ্বাণী",
			"িছ": "িচ",
			"িশ": "িচ",
			"ৈশ": "ৈচ",
			"ৈছ": "ৈচ",
			"ইছ": "ইচ",
			"ইশ": "ইচ",
			"ল্লিছ": "ল্লিচ",
			"ল্লিশ": "ল্লিচ",
			"লিচ": "ল্লিচ",
			"লিছ": "ল্লিচ",
			"লিশ": "ল্লিচ",
			"উন": "ঊন",
			"পয়": "পঁই",
			"পই": "পঁই",
			"পঁয়": "পঁই",
			"িৰা": "িয়া",
			"িয়া": "িৰা",
			"ষোল": "ষোল্ল",
			"চৌধ": "চৈধ্য",
			"চৌধ্য": "চৈধ্য",
			"নব্বৈ": "ন্নব্বৈ",
			"নবৈ": "ন্নব্বৈ",
			"ন্নবৈ": "ন্নব্বৈ",
			"বিৰাল্লিচ": "বিয়াল্লিচ",
			"তিৰাল্লিচ": "তিয়াল্লিচ",
			"চৌৰাল্লিচ": "চৌচল্লিচ",
			"চৌৱাল্লিচ": "চৌচল্লিচ",
			"চৌৱন্ন": "চৌৱন",
			"ঊনসতৰ": "ঊনসত্তৰ",
			"ঊনসতোৰ": "ঊনসত্তৰ",
			"বিয়াশী": "বিৰাশী",
			"ছিয়াশী": "ছয়াশী",
			"পচিচ": "পঁচিচ",
			"পঁশিচ": "পঁচিচ",
			"পঁচিশ": "পঁচিচ",
			"পঁছিশ": "পঁচিচ",
			"ঞ্চাশ": "ঞ্চাচ",
			"চতুঃশীতি": "চতুৰ্শীতি",
			"অষ্ট": "অষ্টা",
			"অষ্টা": "অষ্ট",
			"ত্ৰয়শীতি": "ত্ৰ্যশীতি",
			"ত্ৰয়োশীতি": "ত্ৰ্যশীতি",
			"দ্বা": "দ্ব্যা",
			"নৱ": "নৱা",
			"কৰ্দয": "কদৰ্য",
			"চেতীয়া": "চেটিয়া",
			"চিতীয়া": "চেটিয়া",
			"চিটিয়া": "চিতীয়া",
			"চিটীয়া": ["চিতীয়া", "চেটিয়া"],
			"চেটিয়া": "চেতিয়া",
			"চেটীয়া": "চেটিয়া",
			"ফ্ৰয়ড": "ফ্ৰইড",
			"ফ্ৰয়েড": "ফ্ৰইড",
			"ক্ৰীড়া": "ক্ৰিয়া",
			"ক্ৰিড়া": "ক্ৰীড়া",
			"ক্ৰিয়া": "ক্ৰীড়া",
			"পুনৰো": "পুনৰু",
			"বাজী": "বাজি",
			"শাস্তিপ্ৰদান": "শাস্তিদান",
			"নিঃব": "নিৰ্ব",
			"নিস্": "নিষ্",
			"দুস্": "দুষ্",
			"বিস্": "বিষ্",
			"ৰিস্": "ৰিষ্",
			"উদীপ্ত": "উদ্দীপ্ত",
			"অসদব্যৱহৃত": "অসদ্ব্যৱহৃত",
			"জুডেই": "জুদেই",
			"জুডা": "জুদা",
			"মূৰব্বী": "মুৰব্বী",
			"সন্তপৰ্ণে": "সন্তৰ্পণে",
			"গুল": "গোল",
			"অভ্যন্তৰিক": "আভ্যন্তৰিক",
			"ওৱা": "ৱা",
			"কৌতু": "কৌতূ",
			"শন্নিপাত": "সন্নিপাত",
			"শনিপাত": "সন্নিপাত",
			"সনিপাত": "সন্নিপাত",
			"শলি": "সলি",
			"সলি": "শলি",
			"উকাল": "ওকাল",
			"ওকিল": "উকীল",
			"ওকীল": "উকীল",
			"উকিল": "উকীল",
			"সামৰ্থ": "সামৰ্থ্য",
			"গেছয়": "গেছী",
			"বক্ৰ": "বক্ৰী",
			"অংগ": "অংগী",
			"আয়ন": "আয়নী",
			"অশ্ম": "অশ্মী",
			"বিচূৰ্ণ": "বিচূৰ্ণী",
			"শীতল": "শীতলী",
			"খণ্ড": "পিণ্ডী",
			"উৎসৰ্গ": "উৎসৰ্গী",
			"ঘন": "ঘনী",
			"কেন্দ্ৰ": "কেন্দ্ৰী",
			"সামূহিক": "সামূহিকী",
			"যৌগ": "যৌগী",
			"প্ৰমাণ": "প্ৰমাণী",
			"তৰল": "তৰলী",
			"সম্বন্ধ": "সম্বন্ধী",
			"অম্ল": "অম্লী",
			"এচিড": "এচিডী",
			"বিষয়": "বিষয়ী",
			"বিশেষ": "বিশেষী",
			"উদাৰ": "উদাৰী",
			"মানক": "মানকী",
			"আৰ্য": "আৰ্যী",
			"পৃথক": "পৃথকী",
			"বাণিজ্যিক": "বাণিজ্যিকী",
			"দীৰ্ঘ": "দীৰ্ঘী",
			"সামাজিক": "সামাজিকী",
			"বিষম": "বিষমী",
			"স্পষ্ট": "স্পষ্টী",
			"স্থিৰ": "স্থিৰী",
			"সবল": "সবলী",
			"পিণ্ড": "পিণ্ডী",
			"শুদ্ধী": "শুদ্ধি",
			"শুদ্ধ": "শুদ্ধি",
			"যন্ত্ৰ": "যন্ত্ৰী",
			"ভস্ম": "ভস্মী",
			"বাষ্প": "বাষ্পী",
			"বাজ": "বাজী",
			"বশ": "বশী",
			"বৰ্গ": "বৰ্গী",
			"বনান": "বনানী",
			"প্ৰাদেশিক": "প্ৰাদেশিকী",
			"নগৰ": "নগৰী",
			"পবিত্ৰ": "পবিত্ৰী",
			"পক": "পকী",
			"নিৰস্ত্ৰ": "নিৰস্ত্ৰী",
			"নগ্ন": "নগ্নী",
			"দ্ৰৱ": "দ্ৰৱী",
			"দৃঢ়": "দৃঢ়ী",
			"একত্ৰ": "একত্ৰী",
			"আধুনিক": "আধুনিকী",
			"আত্ম": "আত্মী",
			"অন্ধ": "অন্ধী",
			"নিৰ্জল": "নিৰ্জলী",
			"অৱজ্ঞিত": "অৱজ্ঞাত",
			"উপহাসিত": "উপহসিত",
			"সংলগ্ন": "সংলগ্নী",
			"নুবাদী": "নুবাদক",
			"কত্বসুলভ": "কসুলভ",
			"সত্ব": "সত্ত্ব",
			"নিমচাপ": "নিমচাক",
			"লাহনী": "লাঢ়নী",
			"সতী": "সতি",
			"সং": "সম",
			"সিংখাপ": "কিংখাপ",
			"সুধন্বা": "সুধম্বা",
			"সৌগত": "সুগত",
			"স্থপতিবিদ": ["স্থপতি", "স্থাপত্যবিদ"],
			"স্বায়ত্ব": "স্বায়ত্ত",
			"স্বায়ত্ত্ব": "স্বায়ত্ত",
			"স্বায়ত": "স্বায়ত্ত",
			"ব্যাভিচাৰ": "ব্যভিচাৰ",
			"ভাগিৰথী": "ভাগীৰথী",
			"সামন্তৰিক": "সামান্তৰিক",
			"উশৃংখল": "উচ্ছৃংখল",
			"পাপীষ্ঠ": "পাপিষ্ঠ",
			"পুঙ্খানুপুঙ্খ": "পুংখানুপুংখ",
			"নিঃচি": "নিশ্চি",
			"নিচি": "নিশ্চি",
			"ঘিঁউ": "ঘিউ",
			"হদিচ": "হাদিচ",
			"শিংকি": "হিংকি",
			"গুজৰ": "গোজৰ",
			"হৱিষ": "হবিষ",
			"হৱিচ": "হবিচ",
			"পোৱঁতী": "পোৱাঁতী",
			"মৰতী": "মৰঁতী",
			"কবাব": "কাবাব",
			"টোপী": "তোপে",
			"টোপে": "তোপে",
			"সবৰমতী": "সাবৰমতী",
			"সূচাংক": "সূচকাংক",
			"আমোঘ": "অমোঘ",
			"প্ৰস্ৰাৱগাৰ": "প্ৰস্ৰাৱাগাৰ",
			"হাস্যস্পদ": "হাস্যাস্পদ",
			"একেধাৰে": "একাধাৰে",
			"অশ্বত্থমা": "অশ্বত্থামা",
			"পুৰোহিতানী": "পুৰোহিতনী",
			"ডৌল": "দৌলত",
			"অস্তমান": "অস্তায়মান",
			"টাংচা": "তাংচা",
			"গাঁতুৱা": "গঁতুৱা",
			"আলম্যান": "আলিমান",
			"মংগলা": "মঙলা",
			"ওমৰাহ": "উমৰাহ",
			"দুৰ্ভিলাষ": "দুৰভিলাষ",
			"ভকলী": "ভেকুলী",
			"তফচিল": "তপচিল",
			"সংবেশ": "সংবেশন",
			"ঘোগুৰা": "ঘোগোৰা",
			"কেৰাটি": "কেৰাটে",
			"ঝেমালা": "ঝেমেলা",
			"জেমেলা": "ঝেমেলা",
			"নিৰক্ত": "নীৰক্ত",
			"নিৰোগী": "নীৰোগী",
			"তৰধনি": "তৰ্ধনি",
			"সঁজাতি": "সঁজাতী",
			"উদ্ভান্ত": "উদ্ভ্ৰান্ত",
			"আঁকৰা": "অঁকৰা",
			"আজলা": "অজলা",
			"আপূৰঠ": "অপূৰঠ",
			"আবতৰ": "আবতৰ",
			"প্ৰাদেশী": "প্ৰাদেশিকী",
			"বাণিজ্যি": "বাণিজ্যিকী",
			"ঘেয়ামি": "ঘেৰামি",
			"পাজৰ": "পাঁজৰ",
			"কোণীয়া": "কুণীয়া",
			"ছিৰি": "চিৰি",
			"ছিৰী": "চিৰী",
			"শোঁত": "সোঁত",
			"শোঁট": "সোঁত",
			"শোঙ": "শুঙ",
			"শোং": "শুঙ",
			"জাৰু": "জাড়ু",
			"ঝাৰু": "ঝাড়ু",
			"পজৰাই": "পোজৰাই",
			"পঁজৰাই": "পোজৰাই",
			"পোঁজৰাই": "পোজৰাই",
			"সৃজনীশীল": "সৃজনশীল",
			"চচিয়েল": "ছ’চিয়েল",
			"চছিয়েল": "ছ’চিয়েল",
			"ছছিয়েল": "ছ’চিয়েল",
			"নেলীয়া": "নলীয়া",
			"বেমেলি": "বেমালি",
			"বেমূলীয়া": "বেমালি",
			"বিৰোধিতা": "বিৰোধ",
			"জোৰা": "যোৰা",
			"জুৰি": "যুৰি",
			"সাম্প্ৰদায়িকতাবাদ": "সাম্প্ৰদায়বাদ",
			"সাম্ৰাজ্ঞী": "সম্ৰাজ্ঞী",
			"সামাজ্ঞী": "সম্ৰাজ্ঞী",
			"সমাজ্ঞী": "সম্ৰাজ্ঞী",
			"তুল্য": "তুল্যা",
			"তুল্যা": "তুল্য",
			"দুকাঁ": "দুআঁ",
			"চ্ছ্বাসিত": "চ্ছ্বসিত",
			"দীপ্তমান": "দীপ্তিমান",
			"বিজ্ঞানিক": "বৈজ্ঞানিক",
			"সমুখীন": "সন্মুখীন",
			"সাতেপাছে": "সাতেপাঁচে",
			"ডেকচি": "ডেগচি",
			"তপিলা": "তপিনা",
			"বেচা": "বেচে",
			"মিয়া": "মিঞা",
			"মিঁয়া": "মিঞা",
			"শেল": "হেল",
			"হেল": "শেল",
			"টাইলছ": "টাইল",
			"চকলা": "চকল",
			"চকল": "চকলা",
			"চচালি": "চঁচালি",
			"চচালী": "চঁচালি",
			"চঁছালি": "চঁচালি",
			"চঁচালী": "চঁচালি",
			"চছালি": "চঁচালি",
			"ছচালি": "চঁচালি",
			"ছঁচালি": "চঁচালি",
			"ছছালি": "চঁচালি",
			"ছঁছালি": "চঁচালি",
			"চিয়াহি": "চিয়াহী",
			"চিঁয়াহি": "চিয়াহী",
			"চিঁঞাহি": "চিয়াহী",
			"চিঁয়াহী": "চিয়াহী",
			"চিঁঞাহী": "চিয়াহী",
			"চিঞাহী": "চিয়াহী",
			"পেড়া": "পেৰা",
			"টেপা": "টিপা",
			"ছিলট": "চিলট",
			"চিলঠ": "চিলথ",
			"ষ্টেথিস্ক’প": "ষ্টেথস্ক’প",
			"ষ্ট্ৰেচাৰ": "ষ্ট্ৰেচ্চাৰ",
			"ষ্টেচাৰ": "ষ্ট্ৰেচ্চাৰ",
			"লেঙি": "লাঙি",
			"লেঙী": "লাঙি",
			"লাঙী": "লাঙি",
			"বক্ষযুগল": "স্তনযুগল",
			"তহঁতবিলাক": "তহঁত",
			"তহঁতবোৰ": "তহঁত",
			"ইহঁতবিলাক": "ইহঁত",
			"ইহঁতবোৰ": "ইহঁত",
			"নোৱাৰা": "নোৱৰা",
			"দৈঘ্য": "দৈৰ্ঘ্য",
			"নাতিদৈৰ্ঘ্য": "নাতিদীৰ্ঘ",
			"নাতিদৈঘ্য": "নাতিদীৰ্ঘ",
			"বছেৰেকীয়া": "বছৰেকীয়া",
			"বোঁৱতি": "বোৱঁতী",
			"বোঁৱতী": "বোৱঁতী",
			"বোৱতী": "বোৱঁতী",
			"ৰলৈ": "লৈ",
			"ত্বম": "তম",
			"ত্তম": "তম",
			"বিদেহী": "বিদেহ",
			"সৰোগত": "সাৰোগত",
			"প্ৰজন্মে": "প্ৰজন্মই",
			"আকোঁৱা": "আঁকোৱা",
			"জুৰুন": "জোৰোন",
			"ৰূহ": "ৰুহ",
			"দিন": "দিনা",
			"দিনা": "দিন",
			"ছট": "চট",
			"চট": "ছট",
			"সৈন্যাসী": "সন্ন্যাসী",
			"সন্যাসী": "সন্ন্যাসী",
			"ছালিসা": "চালিচা",
			"চালিসা": "চালিচা",
			"চালিশা": "চালিচা",
			"দুস্মন": "দুচমন",
			"দুষ্মন": "দুচমন",
			"চাউনী": "ছাউনি",
			"পঞ্জাৱ": "পাঞ্জাব",
			"পঞ্জাব": "পাঞ্জাব",
			"বিদুষিণী": "বিদুষী",
			"শিক্ষয়ত্ৰী": "শিক্ষয়িত্ৰী",
			"ফৰিস্তা": "ফিৰিস্তা",
			"স্বাক্ষকাৰী": "স্বাক্ষৰকাৰী",
			"স্বাক্ষৰ": "সাক্ষৰ",
			"সাক্ষৰ": "স্বাক্ষৰ",
			"সৰ্বান্ত": "সৰ্বান্তঃ",
			"আৰ্শীবাদ": "আশীৰ্বাদ",
			"আৰ্শিবাদ": "আশীৰ্বাদ",
			"মীণ": "মীন",
			"একচি": "এক্সি",
			"ধাৱমানিত": "ধাৱমান",
			"এক্ষন্তেক": "এখন্তেক",
			"ঔপনিৱেশ": "উপনিৱেশ",
			"চাইন্স": "ছায়েন্স",
			"চায়েন্স": "ছায়েন্স",
			"ছাইন্স": "ছায়েন্স",
			"আচন্দাই": "আচন্দ্ৰাই",
			"সকিয়নী": "সকীয়নি",
			"কান্য": "কন্যা",
			"লব্ধপ্ৰতিষ্ঠিত": "লব্ধপ্ৰতিষ্ঠি",
			"মৃৎমেলা": "মৃৎশিল্পমেলা",
			"ভেটেৰিনাৰী": "ভেটেৰিনেৰি",
			"ভেটেৰিনাৰি": "ভেটেৰিনেৰি",
			"ভেটেৰিনেৰী": "ভেটেৰিনেৰি",
			"অলগদ্ধ": "অলগৰ্ধ",
			"অলগৰ্দ্ধ": "অলগৰ্ধ",
			"কুচিপুৰি": "কুচিপুড়ি",
			"কুচ্চিপুৰি": "কুচিপুড়ি",
			"কুচ্চিপুৰী": "কুচিপুড়ি",
			"কুচিপুৰী": "কুচিপুড়ি",
			"আয়ত্ত্বাধীন": "আয়ত্ত",
			"আয়ত্তাধীন": "আয়ত্ত",
			"আয়ত্বাধীন": "আয়ত্ত",
			"যথাৰ্থতা": "যথাৰ্থ",
			"ব্যক্তিক্ৰম": "ব্যতিক্ৰম",
			"প্ৰতীকীবাদ": "প্ৰতীকবাদ",
			"ছত্তিশ": "ছত্তিচ",
			"ক্ষুন্ন": "ক্ষুণ্ণ",
			"চত্তিশ": "ছত্তিচ",
			"চ্যেলুট": "ছেল্যুট",
			"নিখুট": "নিখুঁত",
			"নিখুঁট": "নিখুঁত",
			"বাৰ্ধ্যক": "বাৰ্ধক্য",
			"ওৰাংওটাং": "ওৰাংউটাং",
			"উৰাংওটাং": "ওৰাংউটাং",
			"উৰাংউটাং": "ওৰাংউটাং",
			"সুদুত্তৰ": "সদুত্তৰ",
			"ৰচিয়তা": "ৰচয়িতা",
			"প্ৰাক্‌চৰ্ত": "পূৰ্বচৰ্ত",
			"প্ৰাকচৰ্ত": "পূৰ্বচৰ্ত",
			"অৰ্ধস্তন": "অধঃস্তন",
			"অগণণ": "অগণন",
			"মধুসুদন": "মধুসূদন",
			"ভেল্কিবাজী": "ভেল্কীবাজি",
			"ভেল্কীবাজী": "ভেল্কীবাজি",
			"ভেল্কিবাজি": "ভেল্কীবাজি",
			"প্ৰত্যায়ন্ত": "প্ৰত্যয়ান্ত",
			"ভৰপূৰ্ণ": "ভৰপূৰ",
			"শোষ": "শোহ",
			"চূৰান্ত": "চূড়ান্ত",
			"চুড়ান্ত": "চূড়ান্ত",
			"চুৰান্ত": "চূড়ান্ত",
			"খোছাৰ": "খোঁচাৰ",
			"ভংগী": "ভংগি",
			"ধংশ": "ধ্বংস",
			"ত্ৰাসি": "ত্ৰাহি",
			"যাই": "গৈ",
			"জিব": "জীৱ",
			"উলু": "উলূ",
			"ঊলু": "উলূ",
			"ঊলূ": "উলূ",
			"ক্ষ্ম": "হ্ম",
			"য়য়ে": "য়ই",
			"উয়ে": "ৱে",
			"লোহে": "লোঁহেঁ",
			"ছোহে": "ছোঁহেঁ",
			"উখুন": "ওখোন",
			"তিতা": "তিয়া",
			"তিতো": "তিও",
			"ঘড়িয়াল": "ঘঁৰিয়াল",
			"কালপিত": "কালপ্ৰিট",
			"সীসীয়া": "সীসিয়া",
			"জকজকা": "জঁকজঁকা",
			"অপৰাগ": "অপাৰগ",
			"নিতোওৱা": "নিতিওৱা",
			"নিতোৱা": "নিতিওৱা",
			"নিনোৱা": "নিনিওৱা",
			"কেদি": "ককদি",
			"ৰেই": "ৰে",
			"য়েহে": "হে",
			"তৰে": "তেৰে",
			"দিহে": "দি",
			"য়েইহে": "হে",
			"সিয়া": "তা",
			"হেহঁক": "হঁকহে",
			"াওঁ": "োৱাওঁ",
			"লুৰুক": "লোৰোক",
			"দিপাৱলী": "দীপাৱলী",
			"দীপাৱলি": "দীপাৱলী",
			"কঠীয়াতলি": "কঠীয়াতলী",
			"কঠিয়াতলী": "কঠীয়াতলী",
			"কঠিয়াতলি": "কঠীয়াতলী",
			"আটচবাজী": "আতচবাজি",
			"আটছবাজি": "আতচবাজি",
			"আতছবাজী": "আতচবাজি",
			"হেহেঁতেন": "হেঁতেনহে",
			"হেহ’লে": "হ’লেহে",
			"হেঁতে": "হেঁতেন",
			"মাধ্যম": "মধ্যম",
			"কৈও": ["কৈ", "কেও", "কৈয়ে"],
			"ক্ৰুটি": "ত্ৰুটি",
			"নটেশ্বৰী": "নাটেশ্বৰী",
			"ভাৰত": "ভৰত",
			"বটুটা": "বতুতা",
			"সাম্ভাব্য": "সম্ভাব্য",
			"ষাড়জনী": "ষাঁড়টো",
			"গাৱে": "গাৱেঁ",
			"গাৱ": "গাৱঁ",
			"উজ্জ্বলা": "উজলা",
			"বিষন্ন": "বিষণ্ণ",
			"উইছিৰিঙা": "উঁইচিৰিঙা",
			"তুমুৰলি": "তুমৰলি",
			"ফনীভুষণ": "ফণীভূষণ",
			"দ্বান্দিক": "দ্বান্দ্বিক",
			"ৰামানুজম": "ৰামানুজন",
			"বিজিনেছ": "বিজনেছ",
			"নিৰ্মীয়মান": "নিৰ্মীয়মাণ",
			"প্ৰত্যাহবান": "প্ৰত্যাহ্বান",
			"যুঁৱলী": "যুৱলি",
			"কৃৰ্তিচিহ্ন": "কীৰ্তিচিহ্ন",
			"চাক্ষুস": "চাক্ষুষ",
			"উদ্গীৰণ": "উদগীৰণ",
			"আন্তৰাষ্টীয়": "আন্তঃৰাষ্ট্ৰীয়",
			"নাৰ্চাৰী": "নাৰ্ছাৰি",
			"স্বাৰ্থন্বেষী": "স্বাৰ্থান্বেষী",
			"বৰ্হিঃগমণ": "বৰ্হিঃগমন",
			"চেল্যুট": "ছেলুট",
			"ছ্যেলুট": "ছেলুট",
			"ভঁহা": "ভহা",
			"প্ৰতিত্তোৰ": "প্ৰত্যুত্তৰ",
			"পৈত্ৰিক": "পৈতৃক",
			"নন্দেক": "ননন্দেক",
			"উড়ি": "ওড়ি",
			"বহ্ম": "ব্ৰহ্ম",
			"ডখৰ": "ডোখৰ",
			"দৰিয়াওতা": "দঁৰিয়াওঁতা",
			"দোষোতা": "দূষোঁতা",
			"খাইয়ে": "খায়ে",
			"প্ৰতিদ্বন্দী": "প্ৰতিদ্বন্দ্বী",
			"বীৰংগণা": "বীৰাংগনা",
			"প্ৰত্যকৰে": "প্ৰত্যেকৰে",
			"ধংসস্তুপ": "ধ্বংসস্তূপ",
			"ভিডিও": "ভিডিঅ’",
			"চোচোৰাই": "চোঁচৰাই",
			"বান্ধবী": "বান্ধৱী",
			"নিউইয়ৰ্ক": "নিউয়ৰ্ক",
			"কেৰোন": "কেৰোণ",
			"নৈঋত": "নৈৰ্ঋত",
			"গোঁজৰণি": "গোজৰনি",
			"ধবংস": "ধ্বংস",
			"নিৰ্মিয়মান": "নিৰ্মীয়মাণ",
			"জেষ্ঠ‍্য": "জ্যেষ্ঠ",
			"কন্টেন্ট": "কণ্টেণ্ট",
			"হূলস্থুল": "হুলস্থূল",
			"ভুঁঞা": "ভূঞা",
			"ধ্বজ্জা": "ধ্বজা",
			"উইধান": "উৰিধান",
			"সোতমোচ": "শোটমোচ",
			"প্লেটুন": "প্লাটুন",
			"ং": "ঙ",
			"ড়": ["ড়", "ঢ়"],
			"র": ["ৰ", "ৱ"],
			"ৌ": ["ো", "ু"],
			"াঁ": "া",
			"ুঁ": "ু",
			"য়া": "ড়া",
			"উ": "ঔ",
			"ওঁ": "ও",
			"শ্চ": "ঃচ",
			"শ্ছ": "ঃছ",
			"কি": ["কেই", "কী", "কিঁ", "কীঁ"],
			"কী": "কি",
			"কৈ": "ক",
			"কৌ": "ক",
			"ক্ৰু": "ত্ৰু",
			"যু": "মু",
			"যে": "মে",
			"ড০": ["ড॰", "ড:"],
			"ড0": ["ড॰", "ড:"],
			"ডাঃ": ["ডা:", "ড॰"],
			"ঃ": [":", "॰"],
			":": ["ঃ", "॰"],
			"া": ["াঁ", "ুৱা"],
			"িি": "ি",
			"াা": "া",
			"েে": "ে",
			"‍্য": "্য",
			"াে": ["ে", "া", "ো"],
			"িঁ": ["ি", "ী", "ীঁ"],
			"ি": ["ী", "িঁ", "ীঁ"],
			"ী": ["ি", "িঁ", "ীঁ"],
			"ীঁ": ["িঁ", "ী","ি"],
			"িে": ["ি", "ে"],
			"ে": ["েঁ", "ৈ"],
			"ু": ["ূ", "ুঁ", "ো"],
			"ুৱা": ["া", "োৱা", "ুওৱা"],
			"ূ": ["ু", "ো", "ৌ"],
			"ো": ["ু", "োঁ", "ৌ", "ও"],
			"োৱা": ["ুওৱা", "ুৱা", "োওৱা"],
			"অ": ["অঁ", "আ", "আঁ", "এ", "অ’", "ও"],
			"আ": ["অ", "আঁ", "অঁ", "এ"],
			"ই": ["য়", "য়ে", "ঈ"],
			"ইয়া": ["য়া", "ইয়াৰ"],
			"এ": ["অ", "এঁ", "আ", "ঐ"],
			"ও": ["অ’", "ওঁ", "ত্ত", "ঔ", "উ", "য়", "ৱ"],
			"োওৱা": ["োৱা", "ওৱা", "ুওৱা"], 
			"ওৱাও": ["ৱা", "ওৱা", "ুওৱা"],
			"ৱোৱা": ["ৱা", "ওৱা", "ুওৱা"],
			"ক": ["কঁ", "ক’", "কা", "কাঁ", "কু"],
			"কা": ["কাঁ", "ক’", "কঁ", "বা"],
			"খ": ["খঁ", "থ","স", "ষ", "শ", "ক্ষ"],
			"খো": "খু",
			"খু": "খো",
			"গ": ["গঁ", "গা", "ঘ"],
			"গাঁও": ["গাও", "গাৱঁ", "গাঁৱ"],
			"গো": ["গোঁ", "গু", "গ", "গৌ"],
			"ঘঁ": ["ঘ", "ঘাঁ", "ঁঘ"],
			"ঘ": ["ঘঁ", "ঘা", "ঘো", "ঁঘ"],
			"ঘু": ["ঘূ", "ঘুঁ", "ঘো"],
			"ঘূ": ["ঘু", "ঘূঁ", "ঘো"],
			"ঙঁ": ["ঙ"],
			"ঙ": ["ং", "ঙা"],
			"ঙি": ["ঙী"],
			"চ": ["ছ", "চঁ", "চা", "শ", "ঢ", "ট"],
			"চা": ["ছা", "চ", "চাঁ", "শা"],
			"চি": ["ছি", "চিঁ", "চী", "শি"],
			"চু": ["ছু", "চুঁ", "চো", "ছো"],
			"চৌ": ["ছৌ", "টৌ", "ঢৌ"],
			"চ্চ": ["চ্ছ", "শ্চ", "চ্ছ্ব"],
			"ছ": ["চ", "ছা", "ছঁ"],
			"ছা": ["চা", "ছাঁ", "ছ"],
			"ছি": ["চি", "ছিঁ", "ছী"],
			"ছু": ["চু", "ছুঁ", "ছ্যু"],
			"জ": ["য", "জঁ", "জা"],
			"খন": ["টো", "টা", "টি"],
			"খনি": ["টো", "খিনি", "টা", "টি"],
			"জন": ["জনী", "টো", "জনা"],
			"জনি": ["জনী", "জন", "কেইজনী"],
			"জনী": ["জনি", "জন", "জনা", "টো"],
			"জ্ব": ["জ্জ্ব", "জ"],
			"জ্জ": ["জ্জ্ব", "জ", "জ্ব"],
			"ঞ্চ": ["ন্স", "ঞ্ছ", "ষ্ণ"],
			"ঞ্জ": ["ঞ্জা", "জ্ঞ", "নজ"],
			"জ্ঞ": ["ঞ্জ", "ঞ্জা", "জ্ঞা"],
			"জ্ঞা": ["ঞ্জা", "জ্ঞ"],
			"ট": ["ত", "ট্ট", "টঁ", "চ", "ঢ"],
			"টি": ["টী", "তি", "ঢি", "খনি", "জনী", "ডালি"],
			"টী": ["টি", "তি"],
			"টু": ["টো", "টুঁ", "তু", "তো", "জনী"],
			"টো": ["টু", "টোঁ", "তো", "তু", "জন", "জনী", "খন", "ডাল"],
			"ট্ট": ["ত্ত", "ট", "টঁ"],
			"ট্ৰ": ["ত্ৰ", "ট্ট"],
			"ঠ": ["থ", "ঠ্ঠ", "ঠঁ", "থঁ"],
			"ড": ["দ", "ড়", "ডা", "ডঁ"],
			"ঢ": ["ধ", "ঢ়", "ঢঁ", "ট", "চ"],
			"ন্ড": ["ণ্ড", "ন্দ"],
			"ণ": ["ন", "ণা", "ৰ্ণ"],
			"ত্‍": ["ৎ", "ত"],
			"ত": ["ট", "তঁ", "তা", "ৎ"],
			"তি": ["তৃ", "তিঁ", "ত্তি"],
			"তু": ["তো", "টু", "তৌ"],
			"তো": ["তু", "টো", "টু", "তৌ"],
			"ত্ৰু": ["ক্ৰু", "ট্ৰু"],
			"ত্ব": ["ত্ত", "ত্বা", "ত্তা","ত্ত্ব", "ত্ত্বা"],
			"ত্ত": ["ত্ব", "ত্তা","ত্তা", "ত্ৰ", "ত্ত্ব", "ও"],
			"ত্ত্ব": ["ত্ব", "ত্ত"],
			"থ": ["ঠ", "থঁ", "খ"],
			"দ": ["ড", "দা", "দঁ", "দ্দ"],
			"দুঃ": ["দু"],
			"দো": ["দূ", "দু", "দোঁ"],
			"দ্ধ": ["ধ", "ব্ধ", "ধ্ব"],
			"ধ": ["ধঁ", "ধা", "ধ্ব", "ঢ"],
			"ধও": ["ধো", "ধত"],
			"ন": ["ণ", "না", "ৰ্ন", "নঅ"],
			"নঁ": ["ন", "না"],
			"নজ": ["ঞ্জ"],
			"নাঁ": ["না", "ন"],
			"নি": ["নী", "নিঃ", "ণি", "ণী"],
			"নী": ["নি", "ণি", "ণী"],
			"নৈ": ["ন", "মৈ", "নে"],
			"নো": ["ণো", "নু", "নৌ"],
			"নোঁ": ["নো", "নু", "নৌ"],
			"নোশো": ["নুশু", "নুসু", "নুহু"],
			"বৃ": "ব্ৰি",
			"ব়": ["ৱ", "ৰ"],
			"সেঁ": ["ঁসে", "সে", "হে"],
			"হেঁ": ["ঁহে", "ঁসে", "হে"],
			"নোগো": ["নুগু"],
			"নোঘো": ["নুঘু"],
			"নোচো": ["নুচু"],
			"নোছু": ["নুছু"],
			"নোজো": ["নুজু"],
			"নোটো": ["নুটু"],
			"নোঠো": ["নুঠু"],
			"নোডো": ["নুডু"],
			"নোঢো": ["নুঢু"],
			"নোতো": ["নুতু"],
			"নোদো": ["নুদু"],
			"নোধো": ["নুধু"],
			"নোনো": ["নুনু"],
			"নোপো": ["নুপু"],
			"নোপোঁ": ["নুপুঁ"],
			"নোফো": ["নুফু"],
			"নোবো": ["নুবু"],
			"নোভো": ["নুভু"],
			"নোমো": ["নুমু"],
			"নোযো": ["নুযু"],
			"নোৰো": ["নুৰু"],
			"নোলো": ["নুলু"],
			"নোষো": ["নুষু"],
			"নোসো": ["নুসু"],
			"নোহো": ["নুহু"],
			"নৌ": ["ন", "মৌ"],
			"ন্ত": ["ণ্ট", "ন্তা", "ন্তৰ"],
			"ন্ম": ["ম্ম", "ন্মা"],
			"ন্স": ["ঞ্চ", "নছ"],
			"ন্চ": ["ঞ্চ", "ন্স"],
			"প": ["প্ৰ", "পা", "প্ৰা"],
			"পে": ["পেঁ", "প্ৰে"],
			"পেঁ": ["ঁপে", "পে"],
			"প্ৰ": ["প্ৰা", "প", "পা"],
			"প্ৰি": ["প্ৰী", "প্ৰ"],
			"প্ৰী": ["প্ৰি", "প্ৰ"],
			"ব": ["ৱ", "বঁ", "বা", "ভ", "ৰ"],
			"ভ": ["ভঁ", "ভা", "ড", "ড়"],
			"ভু": ["ভূ", "ভো", "ভুঁ", "ভূঁ"],
			"ভূ": ["ভু", "ভো", "ভূঁ"],
			"ম": ["য", "য়", "মু", "ষ", "ৰ্ম", "মা"],
			"মা": ["যা", "ম", "য়া", "ষা"],
			"মি": ["যি", "য়ি", "ষি"],
			"মু": ["মো", "যু", "সু", "ষু"],
			"মে": ["যে", "য়ে", "সে", "ষে"],
			"মৈ": ["যৈ", "সৈ"],
			"মো": ["মু", "যো", "য়ো", "সো", "ষো"],
			"ম্ম": ["ন্ম", "ম্মা"],
			"য": ["জ", "য়", "যা", "ম", "ষ", "যঁ"],
			"ৰ": ["ড়", "ৰঁ", "ৰা", "ৰু", "ৰে", "ড়া", "ব", "ৱ"],
			"ৰা": ["ড়া", "ৰাঁ", "ৰ"],
			"ৰি": ["ৰী", "বি", "ৱি", "ড়ি"],
			"ৰী": ["ৰি", "বী", "ৱী"],
			"ৰু": ["ৰূ", "ৰো", "ড়ু"],
			"ৰূ": ["ৰু", "ৰো"],
			"ৰে": ["ৰ", "ৰৈ", "ড়ে", "ৰো"],
			"ৰো": ["ৰু", "ৰূ", "ৰোঁ", "ড়ো", "ৰ"],
			"ল": ["লে", "লা", "লত", "লেই"],
			"লু": ["লো"],
			"লে": ["ল", "লেই", "লৈ"],
			"লো": ["লেও", "লোঁ"],
			"ৱ": ["ব", "ৱা", "ৱঁ", "ৃ"],
			"ৱে": ["ৱেঁ", "ৱৈ", "য়ে", "ওৱে"],
			"শ": ["চ", "ষ", "স", "শঁ", "ছ", "শা"],
			"ষ": ["শ", "য", "স", "চ", "ম", "হ"],
			"ষ্ট": ["ষ্ঠ", "ষ্ট্য", "ষ্টা", "স্ত", "ষ্ট্ৰ"],
			"ষ্ট্ৰ": ["ষ্ট", "ষ্টা", "স্ত", "স্ত্ৰ"],
			"ষ্ঠ": ["স্থ", "ষ্ট"],
			"ষ্ণ": ["ঞ্চ", "ষ্ক"],
			"স্ক": ["ষ্ক", "স্কা", "ক্স"],
			"ষ্ক": ["স্ক", "ষ্কা"],
			"স": ["শ", "শা", "সা", "হ"],
			"সঁ": ["শঁ", "স", "ঁস", "হঁ"],
			"সা": ["শা", "সাঁ", "হ"],
			"স্ত্ৰ": ["স্ত", "স্ত্ৰা", "ষ্ট", "ষ্ট্ৰ"],
			"স্ত": ["স্তা", "স্থ", "স্ত্ৰ", "ষ্ট", "ষ্টা"],
			"সু": ["সো", "সোঁ", "শু", "শো", "সুঁ", "ষু"],
			"স্থ": ["ষ্ঠ", "স্থা", "স্ত"],
			"হ": ["হঁ", "হা", "স"],
			"হু": ["হুঁ", "হূ", "হো", "হোঁ", "শু", "সু"],
			"য়াঁ": ["ঁয়া", "ঁয়", "ঞা"],
			"য়": ["য়ঁ", "য়া", "য", "ম", "য়াঁ", "ই"],
			"য়ে": ["ই", "ৱে", "ঈয়ে"],
			"য়ও": ["য়ো", "ও", "ইও", "য়েও"],
			"য়ো": ["ও", "ঈও"],
			"ড়": ["ঢ়", "ৰ", "ড", "ডঁ"],
			"ঢ়": ["ড়", "ৰ্হ", "ঢ", "ঢঁ"],
			"ঞঁ": "ঞ",
			"ণঁ": "ণ",
			"মঁ": "ম",
			"ঙাঁ": "ঙা",
			"ঞাঁ": "ঞা",
			"ণাঁ": "ণা",
			"মাঁ": "মা",
			"ঙোঁ": "ঙো",
			"ঞোঁ": "ঞো",
			"ণোঁ": "ণো",
			"মোঁ": "মো",
			"ল্লি": "ল্লে",
			"ক্ষী": "খি",
			"ক্ষি": "খি",
			"পু": "পূ",
			"ৰ্দ্ধ": "ৰ্ধ",
			"ৎ": "ত",
			"ক’": "ক",
			"ন্দ": "ণ্ড",
			"ণ্ড": "ন্দ",
			"খা": "খ",
			"গা": "গ",
			"ঘা": "ঘ",
			"জা": "জ",
			"ঝা": "ঝ",
			"টা": "ট",
			"ঠা": "ঠ",
			"ডা": "ড",
			"ঢা": "ঢ",
			"ণা": "ণ",
			"তা": "ত্ব",
			"থা": "থ",
			"দা": "দ",
			"ধা": "ধ",
			"না": "ন",
			"পা": "প",
			"ফা": "ফ",
			"বা": "ব",
			"ভা": "ভ",
			"যা": "য",
			"লা": "ল",
			"ৱা": "ৱ",
			"শা": "শ",
			"ষা": "ষ",
			"হা": "হ",
			"ক্ষা": "ক্ষ",
			"কূ": "কু",
			"খূ": "খু",
			"গূ": "গু",
			"চূ": "চু",
			"ছূ": "ছু",
			"জূ": "জু",
			"ঝূ": "ঝু",
			"টূ": "টু",
			"ঠূ": "ঠু",
			"ডূ": "ডু",
			"ঢূ": "ঢু",
			"ণূ": "ণু",
			"তূ": "তু",
			"থূ": "থু",
			"দূ": "দু",
			"ধূ": "ধু",
			"নূ": "নু",
			"পূ": "পু",
			"ফূ": "ফু",
			"বূ": "বু",
			"মূ": "মু",
			"যূ": "যু",
			"লূ": "লু",
			"ৱূ": "ৱু",
			"শূ": "শু",
			"ষূ": "ষু",
			"সূ": "সু",
			"হূ": "হু",
			"ক্ষূ": "ক্ষু",
			"ৰ্ক": "কৰ্",
			"ৰ্খ": "খৰ্",
			"ৰ্গ": "গৰ্",
			"ৰ্ঘ": "ঘৰ্",
			"ৰ্চ": "চৰ্",
			"ৰ্ছ": "ছৰ্",
			"ৰ্জ": "জৰ্",
			"ৰ্ঝ": "ঝৰ্",
			"ৰ্ট": "টৰ্",
			"ৰ্ঠ": "ঠৰ্",
			"ৰ্ড": "ডৰ্",
			"ৰ্ঢ": "ঢৰ্",
			"ৰ্ণ": "ণৰ্",
			"ৰ্ত": "তৰ্",
			"ৰ্থ": "থৰ্",
			"ৰ্দ": "দৰ্",
			"ৰ্ধ": "ৰ্ধ্ব",
			"ৰ্ন": "নৰ্",
			"ৰ্প": "পৰ্",
			"ৰ্ফ": "ফৰ্",
			"ৰ্ব": "বৰ্",
			"ৰ্ভ": "ভৰ্",
			"ৰ্ম": "মৰ্",
			"ৰ্য": "যৰ্",
			"ৰ্ল": "লৰ্",
			"ৰ্ৱ": "ৱৰ্",
			"ৰ্শ": "শৰ্",
			"ৰ্ষ": "ষৰ্",
			"ৰ্স": "সৰ্",
			"ৰ্হ": "হৰ্",
			"ৰ্ক্ষ": "ক্ষৰ্",
			"ৰ্জ্ঞ": "জ্ঞৰ্",
			"কৰ্": "ৰ্ক",
			"খৰ্": "ৰ্খ",
			"গৰ্": "ৰ্গ",
			"ঘৰ্": "ৰ্ঘ",
			"চৰ্": "ৰ্চ",
			"ছৰ্": "ৰ্ছ",
			"জৰ্": "ৰ্জ",
			"ঝৰ্": "ৰ্ঝ",
			"টৰ্": "ৰ্ট",
			"ঠৰ্": "ৰ্ঠ",
			"ডৰ্": "ৰ্ড",
			"ঢৰ্": "ৰ্ঢ",
			"ণৰ্": "ৰ্ণ",
			"তৰ্": "ৰ্ত",
			"থৰ্": "ৰ্থ",
			"দৰ্": "ৰ্দ",
			"ধৰ্": "ৰ্ধ",
			"নৰ্": "ৰ্ন",
			"পৰ্": "ৰ্প",
			"ফৰ্": "ৰ্ফ",
			"বৰ্": "ৰ্ব",
			"ভৰ্": "ৰ্ভ",
			"মৰ্": "ৰ্ম",
			"যৰ্": "ৰ্য",
			"লৰ্": "ৰ্ল",
			"ৱৰ্": "ৰ্ৱ",
			"শৰ্": "ৰ্শ",
			"ষৰ্": "ৰ্ষ",
			"সৰ্": "ৰ্স",
			"হৰ্": "ৰ্হ",
			"ক্ষৰ্": "ৰ্ক্ষ",
			"জ্ঞৰ্": "ৰ্জ্ঞ",
			"কূঁ": "কূ",
			"কে": "কেঁ",
			"কৈঁ": "কৈ",
			"কো": "কোঁ",
			"কৌঁ": "কৌ",
			"চো": "ছো",
			"ছো": "চো",
			"নিঃ": "নি",
			"ঙ্ক": "ংক",
			"হ্ন": "হ্ণ",
			"হ্ণ": "হ্ন",
			"ন্ট": "ণ্ট",
			"স্থা": "স্তা",
			"স্ট": "ষ্ট",
			"ব্যা": "ব্য",
			"ব্য": "ব্যা",
			"ো": "ো",
			"ৌ": "ৌ",
			"ইও": "য়ো",
			"য়েও": "ৱেও",
			"ইয়ো": "য়ো",
			"ংও": "ঙো",
			"কো": "কো",
			"খো": "খো",
			"গো": "গো",
			"য়াে": "য়ো",
			"পাে": "পো",
			"ফাে": "ফো",
			"ফো": "ফো",
			"উই": "ৱি",
			"ইউ": "য়ু",
			"ঘো": "ঘো",
			"লী": "লি",
			"লো": "লো",
			"স্প": "ষ্প",
			"ষ্প": "স্প",
			"হে": "হেঁ",
			"কঁ": "ঁক",
			"খঁ": "ঁখ",
			"গঁ": "ঁগ",
			"চঁ": "ঁচ",
			"ছঁ": "ঁছ",
			"জঁ": "ঁজ",
			"ঝঁ": "ঁঝ",
			"টঁ": "ঁট",
			"ঠঁ": "ঁঠ",
			"ডঁ": "ঁড",
			"ঢঁ": "ঁঢ",
			"তঁ": "ঁত",
			"থঁ": "ঁথ",
			"দঁ": "ঁদ",
			"ধঁ": "ঁধ",
			"পঁ": "ঁপ",
			"ফঁ": "ঁফ",
			"বঁ": "ঁব",
			"ভঁ": "ঁভ",
			"যঁ": "ঁয",
			"লঁ": "ঁল",
			"ৱঁ": "ঁৱ",
			"শঁ": "ঁশ",
			"ষঁ": "ঁষ",
			"হঁ": "ঁহ",
			"ক্ষঁ": "ঁক্ষ",
			"জ্ঞঁ": "ঁজ্ঞ",
			"কিঁ": "ঁকি",
			"খিঁ": "ঁখি",
			"গিঁ": "ঁগি",
			"ঘিঁ": "ঁঘি",
			"চিঁ": "ঁচি",
			"ছিঁ": "ঁছি",
			"জিঁ": "ঁজি",
			"ঝিঁ": "ঁঝি",
			"টিঁ": "ঁটি",
			"ঠিঁ": "ঁঠি",
			"ডিঁ": "ঁডি",
			"ঢিঁ": "ঁঢি",
			"তিঁ": "ঁতি",
			"থিঁ": "ঁথি",
			"দিঁ": "ঁদি",
			"ধিঁ": "ঁধি",
			"পিঁ": "ঁপি",
			"ফিঁ": "ঁফি",
			"বিঁ": "ঁবি",
			"ভিঁ": "ঁভি",
			"যিঁ": "ঁযি",
			"লিঁ": "ঁলি",
			"ৱিঁ": "ঁৱি",
			"শিঁ": "ঁশি",
			"ষিঁ": "ঁষি",
			"সিঁ": "ঁসি",
			"হিঁ": "ঁহি",
			"ক্ষিঁ": "ঁক্ষি",
			"জ্ঞিঁ": "ঁজ্ঞি",
			"কীঁ": "ঁকী",
			"খীঁ": "ঁখী",
			"গীঁ": "ঁগী",
			"ঘীঁ": "ঁঘী",
			"চীঁ": "ঁচী",
			"ছীঁ": "ঁছী",
			"জীঁ": "ঁজী",
			"ঝীঁ": "ঁঝী",
			"টীঁ": "ঁটী",
			"ঠীঁ": "ঁঠী",
			"ডীঁ": "ঁডী",
			"ঢীঁ": "ঁঢী",
			"তীঁ": "ঁতী",
			"থীঁ": "ঁথী",
			"দীঁ": "ঁদী",
			"ধীঁ": "ঁধী",
			"পীঁ": "ঁপী",
			"ফীঁ": "ঁফী",
			"বীঁ": "ঁবী",
			"ভীঁ": "ঁভী",
			"যীঁ": "ঁযী",
			"লীঁ": "ঁলী",
			"ৱীঁ": "ঁৱী",
			"শীঁ": "ঁশী",
			"ষীঁ": "ঁষী",
			"সীঁ": "ঁসী",
			"হীঁ": "ঁহী",
			"ক্ষীঁ": "ঁক্ষী",
			"জ্ঞীঁ": "ঁজ্ঞী",
			"কেঁ": "ঁকে",
			"খেঁ": "ঁখে",
			"গেঁ": "ঁগে",
			"ঘেঁ": "ঁঘে",
			"চেঁ": "ঁচে",
			"ছেঁ": "ঁছে",
			"জেঁ": "ঁজে",
			"ঝেঁ": "ঁঝে",
			"টেঁ": "ঁটে",
			"ঠেঁ": "ঁঠে",
			"ডেঁ": "ঁডে",
			"ঢেঁ": "ঁঢে",
			"তেঁ": "ঁতে",
			"থেঁ": "ঁথে",
			"দেঁ": "ঁদে",
			"ধেঁ": "ঁধে",
			"ফেঁ": "ঁফে",
			"বেঁ": "ঁবে",
			"ভেঁ": "ঁভে",
			"যেঁ": "ঁযে",
			"লেঁ": "ঁলে",
			"ৱেঁ": "ঁৱে",
			"শেঁ": "ঁশে",
			"ষেঁ": "ঁষে",
			"ক্ষেঁ": "ঁক্ষে",
			"জ্ঞেঁ": "ঁজ্ঞে",
			"কাঁ": "কা",
			"খাঁ": "খা",
			"গাঁ": "গা",
			"ঘাঁ": "ঘা",
			"চাঁ": "চা",
			"ছাঁ": "ছা",
			"জাঁ": "জা",
			"ঝাঁ": "ঝা",
			"টাঁ": "টা",
			"ঠাঁ": "ঠা",
			"ডাঁ": "ডা",
			"ঢাঁ": "ঢা",
			"তাঁ": "তা",
			"থাঁ": "থা",
			"দাঁ": "দা",
			"ধাঁ": "ধা",
			"পাঁ": "পা",
			"ফাঁ": "ফা",
			"বাঁ": "বা",
			"ভাঁ": "ভা",
			"যাঁ": "যা",
			"লাঁ": "লা",
			"ৱাঁ": "ৱা",
			"শাঁ": "শা",
			"ষাঁ": "ষা",
			"সাঁ": "সা",
			"হাঁ": "হা",
			"ক্ষাঁ": "ক্ষা",
			"কুঁ": "কু",
			"খুঁ": "খু",
			"গুঁ": "গু",
			"ঘুঁ": "ঘু",
			"চুঁ": "চু",
			"ছুঁ": "ছু",
			"জুঁ": "জু",
			"ঝুঁ": "ঝু",
			"টুঁ": "টু",
			"ঠুঁ": "ঠু",
			"ডুঁ": "ডু",
			"ঢুঁ": "ঢু",
			"ণুঁ": "ণু",
			"তুঁ": "তু",
			"থুঁ": "থু",
			"দুঁ": "দু",
			"ধুঁ": "ধু",
			"নুঁ": "নু",
			"পুঁ": "পু",
			"ফুঁ": "ফু",
			"বুঁ": "বু",
			"ভুঁ": "ভু",
			"মুঁ": "মু",
			"যুঁ": "যু",
			"লুঁ": "লু",
			"ৱুঁ": "ৱু",
			"শুঁ": "শু",
			"ষুঁ": "ষু",
			"সুঁ": "সু",
			"হুঁ": "হু",
			"ক্ষুঁ": "ক্ষু",
			"কোঁ": "কো",
			"খোঁ": "খো",
			"গোঁ": "গো",
			"ঘোঁ": "ঘো",
			"চোঁ": "চো",
			"ছোঁ": "ছো",
			"জোঁ": "জো",
			"ঝোঁ": "ঝো",
			"টোঁ": "টো",
			"ঠোঁ": "ঠো",
			"ডোঁ": "ডো",
			"ঢোঁ": "ঢো",
			"তোঁ": "তো",
			"থোঁ": "থো",
			"দোঁ": "দো",
			"ধোঁ": "ধো",
			"পোঁ": "পো",
			"ফোঁ": "ফো",
			"বোঁ": "বো",
			"ভোঁ": "ভো",
			"যোঁ": "যো",
			"লোঁ": "লো",
			"ৱোঁ": "ৱো",
			"শোঁ": "শো",
			"ষোঁ": "ষো",
			"সোঁ": "সো",
			"হোঁ": "হো",
			"ক্ষোঁ": "ক্ষো",
			"বহিঃ": "বহিৰ্",
			"বৰ্হি": "বহিৰ্",
			"বহিৰ্": "বহিঃ",
			"স্খ": "স্থ",
			"স্খা": "স্থা",
			"স্থল": "স্খল",
			"্য়": "্য",
			"ৰ্য্য়": "ৰ্য্য",
			"থূপ": ["থূপী", "থুপি"],
			"সম": ["সং","সহ"],
			"ৰল": ["ৰ’ল"],
			"উজ্ব": ["উজ্জ্ব", "উজ"],
			"ৰ্ভৎ": "ভৰ্ৎ",
			"ভৎৰ্স": "ভৰ্ৎস",
			"য়েক": "ক",
			"তেোঁ": "তেওঁ",
		}
}